module.exports = __webpack_public_path__ + "ca74540b9586b32e7cff656fe392f5d5.svg";